import React from "react";
import MenuSection from "./MenuSection";
import MenuItemSeparator from "./MenuItemSeparator";
import MenuItem from "./MenuItem";
import { isset } from "../../../app/utils/Utils";

export default class MenuList extends React.Component {
    render() {
        const { currentUrl, menuConfig, layoutConfig, funcionalidades } = this.props;

        return menuConfig.aside.items
            .filter((item) => {
                switch (item.page) {
                    case "gerador-de-imagem":
                        return !isset(funcionalidades?.GeradorImagem) || funcionalidades?.GeradorImagem;
                    case "experts":
                        return !isset(funcionalidades?.Experts) || funcionalidades?.Experts;
                    case "gerador-de-voz":
                        return !isset(funcionalidades?.GeradorVoz) || funcionalidades?.GeradorVoz;
                    case "gerador-de-video":
                        return !isset(funcionalidades?.GeradorVideo) || funcionalidades?.GeradorVideo;
                    case "agentes":
                        return !isset(funcionalidades?.Agentes) || funcionalidades?.Agentes;
                    case "viral-short":
                        return !isset(funcionalidades?.ViralShort) || funcionalidades?.ViralShort;
                    case "viral-cut":
                        return !isset(funcionalidades?.ViralCut) || funcionalidades?.ViralCut;
                    default:
                        return true;
                }
            })
            .map((child, index) => {
                return (
                    <React.Fragment key={`menuList${index}`}>
                        {child.section && <MenuSection item={child} />}
                        {child.separator && <MenuItemSeparator item={child} />}
                        {child.title && <MenuItem item={child} currentUrl={currentUrl} layoutConfig={layoutConfig} />}
                    </React.Fragment>
                );
            });
    }
}
